import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
var StrikethroughSvg = function StrikethroughSvg() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: /*#__PURE__*/_jsx("path", {
      fill: "#000",
      d: "M5 4.916A3.416 3.416 0 0 1 8.417 1.5h7.166A3.417 3.417 0 0 1 19 4.917v2.086h-1V4.917A2.417 2.417 0 0 0 15.583 2.5H8.417A2.416 2.416 0 0 0 6 4.916v1.98c0 1.074.709 2.019 1.74 2.32l.005.001 7.541 2.283H23v1H1v-1h10.835l-4.378-1.325A3.42 3.42 0 0 1 5 6.895zM18 15v4.084a2.416 2.416 0 0 1-2.417 2.416H8.417A2.417 2.417 0 0 1 6 19.083v-2.085H5v2.085A3.417 3.417 0 0 0 8.417 22.5h7.166A3.416 3.416 0 0 0 19 19.084V15z"
    })
  });
};
export var Strikethrough = function Strikethrough(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: StrikethroughSvg
  }));
};